<template>
  <div>
    <v-navigation-drawer
      app
      stateless
      width="350"
      expand-on-hover
      v-model="drawer"
    >
      <v-list-item to="/">
        <v-list-item-content title="На главную" :class="$vuetify.theme.dark ? 'logo-white-svg' : 'logo-black-svg'" />
      </v-list-item>

      <v-divider />

      <v-list>
        <v-list-group
          v-for="item in this.groupedMenu"
          :key="item.title"
          v-model="item.active"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <div
            v-for="child in item.items"
            :key="child.title"
          >
            <v-list-item v-if="child.link"
              :href="child.link"
              target="_blank"
            >
              <v-list-item-icon>
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                {{ child.title }}
                <v-icon x-small>mdi mdi-open-in-new</v-icon>
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-else :to="{name: child.route_name}">
              <v-list-item-icon>
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item>

          </div>
        </v-list-group>
      </v-list>

      <template v-slot:append>
        <v-sheet
          class="pl-3 pt-1"
          height="70"
        >
          <v-switch v-model="$vuetify.theme.dark" @change="saveTheme" label="Тема" persistent-hint></v-switch>
        </v-sheet>
      </template>

    </v-navigation-drawer>

    <v-app-bar dense app color="primary" dark>
      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="green accent-4"
      />
      <v-app-bar-nav-icon @click="toggleDrawer" />

      <v-spacer />

      <v-toolbar-items>
        <v-menu v-model="notificationMenuOpen" offset-y @input="loadNotifications">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-badge
                :content="unreadNotificationsCount"
                :value="unreadNotificationsCount"
                color="red"
                overlap
              >
                <v-icon v-if="unreadNotificationsCount">mdi-bell</v-icon>
                <v-icon v-else>mdi-bell-outline</v-icon>
              </v-badge>
            </v-btn>
          </template>

          <v-progress-linear
            :active="loadingNotifications"
            :indeterminate="loadingNotifications"
            absolute
            top
            color="green accent-4"
          />
          <v-list dense min-width="300" class="pb-0">
            <v-list-item v-if="notifications.length === 0">
              <v-list-item-title class="text-center">Нет новых уведомлений</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-else
              v-for="notification in notifications"
              :key="notification.id"
              :style="{ backgroundColor: notification.viewed ? '' : '#28A7452A', }"
              @click="viewNotification(notification.id)"
            >
              <v-list-item-title>{{ notification.title }}</v-list-item-title>
              <v-list-item-subtitle>{{ notification.created_at }}</v-list-item-subtitle>
            </v-list-item>


          </v-list>
          <v-btn block dense class="text-caption text-lowercase" @click="notificationsListOpen = true">
            <span>показать все</span>
          </v-btn>
        </v-menu>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" text>
              <v-icon left>mdi-account</v-icon>
              {{ username }}
            </v-btn>
          </template>

          <v-list>
            <div v-for="menu in topMenus" :key="menu.title">
              <v-list-item v-if="hasRole(menu.roles)" :to="menu.url" link>
                <v-list-item-icon>
                  <v-icon>{{ menu.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ menu.title }}</v-list-item-title>
              </v-list-item>
            </div>
            <v-list-item @click="logout" link>
              <v-list-item-icon>
                <v-icon>mdi-account-arrow-right</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Выйти</v-list-item-title>
            </v-list-item>

          </v-list>
        </v-menu>

      </v-toolbar-items>
    </v-app-bar>
    
    <NotificationsList v-model="notificationsListOpen" />
    <NotificationView
      v-model="notificationOpen"
      :id="notificationId"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NotificationsList from '../partials/dialogs/NotificationsList.vue'
import NotificationView from '../partials/dialogs/NotificationView.vue'

export default {
  components: {
    NotificationsList,
    NotificationView,
  },
  data() {
    return {
      expand_locations: false,
      drawer: true,
      right: null,

      groupedMenu: [],
      notificationMenuOpen: false,
      notifications: [],
      loadingNotifications: false,
      unreadNotificationsCount: 0,
      notificationsListOpen: false,
      notificationId: null,
      notificationOpen: false,
    }
  },

  computed: {
    ...mapGetters('user', ['currentUser', 'hasRole', 'hasPermission', 'topMenus']),
    ...mapGetters({
      loading: 'shared/getLoading',
      report: 'operators/report',
      sideMenu: 'user/sideMenu',
    }),
    username() {
      if (this.currentUser.first_name && this.currentUser.last_name) {
        return `${this.currentUser.first_name} ${this.currentUser.last_name}`
      } else {
        return this.currentUser.login
      }
    },
  },

  methods: {
    ...mapActions({
      logoutUser: 'auth/logout',
      loadSideMenu: 'user/loadSideMenu',
      getNotifications: 'notifications/getNotifications',
      getunreadNotificationsCount: 'notifications/getunreadNotificationsCount',
      setSuccess: 'shared/setSuccess',
    }),
    toggleDrawer() {
      this.drawer = !this.drawer
      localStorage.setItem('drawer', this.drawer);
    },
    logout() {
      this.logoutUser().then(() => {
        if (this.$route.path !== '/') {
          this.$router.push({ path: '/' })
        }
      })
    },
    saveTheme() {
      if (this.$vuetify.theme.dark) {
        localStorage.setItem('app-theme', this.$vuetify.theme.dark)
      } else {
        localStorage.removeItem('app-theme')
      }
    },

    loadNotifications(ev) {
      if (ev === false) {
        this.notifications.length = 0
        return
      }

      this.loadingNotifications = true
      this.getNotifications({
        per_page: 5,
        current_page: 1,
        all_messages: false,
      }).then(resp => {
        this.notifications = resp.data
      }).finally(() => {
        this.loadingNotifications = false
      })
    },

    viewNotification(id) {
      this.notificationId = id
      this.notificationOpen = true
    },

    startSSE() {
      const stream = new EventSource('/sse/notifications', { withCredentials: true })

      stream.addEventListener('notification', (ev) => {
        const data = JSON.parse(ev.data)

        this.setSuccess({
          htmlContent: data.message
        })
      })

      stream.addEventListener('quantity_notifications', (ev) => {
        const data = JSON.parse(ev.data)
        this.unreadNotificationsCount = data.quantity
      })
    },
  },

  mounted() {
    this.loadSideMenu()
      .then(() => {
        const res = []
        const temp = Object.groupBy(this.sideMenu, ({ group }) => group)

        for (const group in temp) {
          const items = temp[group]
          const title = group
          const item = {
            title,
            active: true,
            items
          }

          res.push(item)
        }

        this.groupedMenu = res
      })

    setTimeout(() => {
      let d = localStorage.getItem('drawer');
      if (d) {
        d = JSON.parse(d);
        this.drawer = d;
      }
    }, 1);

    // this.startSSE()
  }
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.logo-black-svg {
  background-image: url('/logo.svg');
  text-align: right;
  height: 66px;
}

.logo-white-svg {
  background-image: url('/logo-grey.svg');
  text-align: right;
  height: 66px;
}
</style>

<style lang="scss">
.v-navigation-drawer__content {
  scrollbar-width: thin;
  scrollbar-color: #28a74552 transparent;

  &::-webkit-scrollbar {
    width: 6px;
    height: 7px;
  }
  &::-webkit-scrollbar-button {
    width: 0px;
    height: 0px;
  }
  &::-webkit-scrollbar-thumb {
    background: #28a74552;
    border: 0px none #ffffff;
    border-radius: 0px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #28a74679;
  }
  &::-webkit-scrollbar-thumb:active {
    background: #28a746a8;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    border: 0px none #ffffff;
    border-radius: 50px;
  }
  &::-webkit-scrollbar-track:hover {
    background: transparent;
  }
  &::-webkit-scrollbar-track:active {
    background: transparent;
  }
  &::-webkit-scrollbar-corner {
    background: transparent;
  }
}
</style>
